import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type ReviewsRelativePath = '/all-reviews' | '/google' | '/facebook' | '/private';

export const featureDefinition = {
  root: '/reviews',
  iconName: 'reviews-dash',
  items: {
    '/all-reviews': {
      label: 'All Reviews',
      trackingId: 'nav-reviews-all-reviews',
      description: 'Aggregates all online reviews across multiple platforms for a unified view and easy management.',
    },
    '/google': {
      label: 'Google',
      trackingId: 'nav-reviews-google',
      description: 'Filters reviews collected specifically from Google, allowing for engagement and management.',
    },
    '/facebook': {
      label: 'Facebook',
      trackingId: 'nav-reviews-facebook',
      description: 'Displays reviews and recommendations sourced from Facebook pages associated with the practice.',
    },
    '/private': {
      label: 'Private',
      trackingId: 'nav-reviews-private',
      description: 'Confidential feedback or private reviews gathered internally, not visible on public platforms.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/reviews', 'reviews-dash', ReviewsRelativePath>;

export const featureExtractionVisibility = {
  groupShowClassification: 'runtime-conditional',
} as const satisfies FeatureExtractionVisibility<ReviewsRelativePath>;
